import { RightOutlined, LeftOutlined } from '@ant-design/icons';

const circleButtonStyle: React.CSSProperties = {
    width: 32,
    height: 32,
    backgroundColor: '#1F8DDD',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
};

const customItemRender = (page: number, type: string, originalElement: React.ReactNode) => {
    if (type === 'prev') {
        return (
            <div style={circleButtonStyle}>
                <LeftOutlined style={{ color: '#fff' }} />
            </div>
        );
    }
    if (type === 'next') {
        return (
            <div style={circleButtonStyle}>
                <RightOutlined style={{ color: '#fff' }} />
            </div>
        );
    }
    return originalElement;
};

export { customItemRender };
